export const config = {
    appName: "Facilitic",
    iva: "0.19",
    rating: {
        cantidadEstrellas: 5,
    },
    roles: {
        supervisor: {
            rol: 1,
            permisos: [
                {
                    menu: "dashboards",
                    opciones: ["dashboard"],
                },
                {
                    menu: "quotes",
                    opciones: ["myquotes"],
                },
                {
                    menu: "orders",
                    opciones: ["orders"],
                },
                {
                    menu: "bills",
                    opciones: ["bills"],
                },
                {
                    menu: "purchases",
                    opciones: ["purchase"],
                },
                {
                    menu: "maintainers",
                    opciones: ["client", "contractors", "catalogue", "taxs","managers"],
                },
            ],
        },
        representante: {
            rol: 3,

            permisos: [
                {
                    menu: "dashboards",
                    opciones: ["dashboard"],
                },
                {
                    menu: "quotes",
                    opciones: ["myquotes"],
                },
                {
                    menu: "orders",
                    opciones: ["orders"],
                },
                {
                    menu: "bills",
                    opciones: ["bills"],
                },
                {
                    menu: "purchases",
                    opciones: ["purchase"],
                },

                {
                    menu: "maintainers",
                    opciones: ["users"],
                },
            ],
        },
        encargado: {
            rol: 4,
            permisos: [
                {
                    menu: "dashboards",
                    opciones: ["dashboard"],
                },
                {
                    menu: "quotes",
                    opciones: ["quote", "myquotes"],
                },
                {
                    menu: "orders",
                    opciones: ["orders"],
                },
                {
                    menu: "bills",
                    opciones: ["bills"],
                },
                {
                    menu: "purchases",
                    opciones: ["purchase"],
                },
            ],
        },
    },
    oott: {
        estados: {
            enviada: {
                id: 1,
                descripcion: "Enviada",
            },
            planificada: {
                id: 2,
                descripcion: "Planificada",
            },
            enEjecucion: {
                id: 3,
                descripcion: "En Ejecución",
            },
            terminada: {
                id: 4,
                descripcion: "Terminada",
            },
            recepcionada: {
                id: 5,
                descripcion: "Recepcionada",
            },
            conObservaciones: {
                id: 6,
                descripcion: "Con Observaciones",
            },
            facturada: {
                id: 7,
                descripcion: "Facturada",
            },
            pagada: {
                id: 8,
                descripcion: "Pagada",
            },
            nueva: {
                id: 0,
                descripcion: "Nueva",
            },
            anulada: {
                id: -1,
                descripcion: "Anulada",
            },
        },
    },
    invitacion: {
        estados: {
            ofertada: {
                id: 1,
                descripcion: "Ofertada",
            },
            aceptada: {
                id: 2,
                descripcion: "Aceptada",
            },
            rechazada: {
                id: 3,
                descripcion: "Rechazada",
            },
        },
    },
    trabajo: {
        estados: {
            adjudicado: {
                id: 1,
                descripcion: "Adjudicado",
            },
            ejecucion: {
                id: 2,
                descripcion: "En ejecución",
            },
            anulado: {
                id: 3,
                descripcion: "Anulado",
            },
            terminado: {
                id: 4,
                descripcion: "Terminado",
            },
            pagado: {
                id: 5,
                descripcion: "Pagado",
            },
        },
    },
};

export const FORMATO_FECHA = {
    parse: {
        dateInput: "DD-MM-YYYY",
    },
    display: {
        dateInput: "DD-MM-YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY",
    },
};
